import type { TOC } from '@ember/component/template-only';
import { formatRating } from '../../utils/format';
import { amazonUrl } from '../../utils/external-urls';

interface Signature {
  Args: { data: Record<string, unknown> | null | undefined };
}

interface ProductData {
  title?: string;
  brand?: string;
  price?: string;
  priceAmount?: number;
  imageUrl?: string;
  rating?: number;
  reviewCount?: number;
  availability?: string;
  isPrime?: boolean;
  asin?: string;
  link?: string;
}

function asProductData(
  raw: Record<string, unknown> | null | undefined
): ProductData {
  return raw ?? {};
}

const ProductDetail: TOC<Signature> = <template>
  {{#let (asProductData @data) as |d|}}
    <div class="flex flex-col gap-3">
      {{#if d.brand}}
        <p class="text-base-content/70 text-sm font-medium">{{d.brand}}</p>
      {{/if}}

      <div class="flex flex-wrap gap-2">
        {{#if d.price}}
          <span class="badge badge-primary">{{d.price}}</span>
        {{/if}}
        {{#if d.isPrime}}
          <span class="badge badge-warning badge-sm">Prime</span>
        {{/if}}
        {{#if d.availability}}
          <span class="badge badge-ghost badge-sm">{{d.availability}}</span>
        {{/if}}
      </div>

      {{#if d.rating}}
        <div class="flex items-center gap-1">
          <span class="text-warning font-bold">★</span>
          <span class="text-sm font-semibold">{{formatRating d.rating}}</span>
          {{#if d.reviewCount}}
            <span class="text-base-content/50 text-xs">({{d.reviewCount}}
              reviews)</span>
          {{/if}}
        </div>
      {{/if}}

      <div>
        {{#if d.asin}}
          <a
            href={{amazonUrl d.asin}}
            target="_blank"
            rel="noopener noreferrer"
            class="btn btn-xs btn-outline"
          >
            View on Amazon ↗
          </a>
        {{else if d.link}}
          <a
            href={{d.link}}
            target="_blank"
            rel="noopener noreferrer"
            class="btn btn-xs btn-outline"
          >
            View product ↗
          </a>
        {{/if}}
      </div>
    </div>
  {{/let}}
</template>;

export default ProductDetail;
